import { render, staticRenderFns } from "./BucketGroupEdit.vue?vue&type=template&id=5f011a0f"
import script from "./BucketGroupEdit.vue?vue&type=script&lang=js"
export * from "./BucketGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports